/* Styles */
import './scss/styles.scss';

/* Scripts */
import './js/main.js';
import './js/colors.js';
